import React from "react";
import PropTypes from "prop-types";
import { IoInformation } from "react-icons/io5";
import { Tooltip as ReactTooltip } from "react-tooltip";

const Instructions = ({ auth }) => (
  <React.Fragment>
    <a
      id="instructions"
      data-tooltip-variant={auth.isNightMode ? "dark" : "light"}
      style={{ marginLeft: "0px !important" }}
    >
      <IoInformation className="icon" size={20} />
    </a>
    <ReactTooltip
      anchorId="instructions"
      className={`custom-tooltip ${auth.isNightMode ? "dark" : "light"}`}
      place="left"
    >
      <div>
        <h5>Controls</h5>
        <p>
          <li>shift + mousewheel = move timeline left/right</li>
          <li>alt + mousewheel = zoom in/out</li>
          <li>meta + mousewheel = zoom in/out (x3)</li>
        </p>
      </div>
    </ReactTooltip>
  </React.Fragment>
);
Instructions.propTypes = {
  auth: PropTypes.object
};

export default Instructions;
